// Copyright (c) 2016 Deere & Company

import './app-navigation.scss';
import { NavLink } from 'react-router-dom';
import React from 'react';

const AppNavigation = () => (
    <nav className="app-navigation">

        <NavLink
            activeClassName="selected"
            className="home"
            to="/welcome"
        >
            <span className="icon-home" />
        </NavLink>
    </nav>
);

AppNavigation.displayName = 'AppNavigation';

export default AppNavigation;
